import { useCallback, useRef } from 'react';
import { DEFAULT_STYLE, DEFAULT_LOCALIZATION } from '../constants';

export const useLiveness = ({ config, params, callbacks }) => {
    const hasStarted = useRef(false);

    const getHtmlLoader = () => {
        const container = document.createElement('div');

        // Contenedor principal centrado
        container.style.cssText = `
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        font-family: sans-serif;
        color: #FFFFFF;
    `;

        // Spinner CSS
        container.innerHTML = `
        <div class="spinner"></div>
        ${config?.style?.loader?.text ? `<p style="margin-top: 15px; font-size: 16px;">${config.style.loader.text}</p>` : ''}
        <style>
            .spinner {
                width: 50px;
                height: 50px;
                border: ${config?.style?.loader?.border || '5px solid rgba(255, 255, 255, 0.3)'};
                border-radius: 50%;
                border-top-color: ${config?.style?.loader?.color || '#FFFFFF'};
                animation: spin 1s ease-in-out infinite;
            }
            @keyframes spin {
                to { transform: rotate(360deg); }
            }
        </style>
    `;

        return container;
    };
    const hideSwitchCamera = () => {
        const style = document.createElement('style');
        style.id = 'oz-hide-switch-camera';
        style.textContent = `
        .ozliveness_recorder_wrap_button > .ozliveness_button._secondary:nth-child(2) {
            display: none !important;
        }
    `;
        if (!document.getElementById('oz-hide-switch-camera')) {
            document.head.appendChild(style);
        }
    };
    const startLiveness = useCallback(() => {
        if (hasStarted.current || typeof window._livenessSDK === 'undefined') return;
        hasStarted.current = true;

        const localization = config?.localization || DEFAULT_LOCALIZATION;
        const langId = config?.lang || params.lang || 'es';
        window._livenessSDK.add_lang(langId, localization);

        const enabledActions = config?.actions?.enabled || ['passive'];
        const availableActions = config?.actions?.available || {};
        const actionCodes = enabledActions.map(a => availableActions[a] || 'video_selfie_blank');

        const sdkConfig = {
            token: config?.token,
            lang: langId,
            action: actionCodes,
            meta: {
                transaction_id: params.transactionId,
                client_id: params.clientId,
                timestamp: new Date().toISOString()
            },
            params: {
                extract_best_shot: config?.settings?.extractBestShot ?? true,
            },
            style: {
                ...(config?.style || DEFAULT_STYLE),
                ...(params.platform === 'ios' && params.emitReadyCam === 'true'
                    ? {}
                    : {
                        loaderSlot: getHtmlLoader(),
                        loaderTransition: { type: 'fade', duration: 500 }
                    })
            },
            cameraFacingMode: config?.settings?.cameraFacingMode || 'user',
            get_user_media_timeout: config?.settings?.cameraTimeout || 40000,
            get_user_media_promise_timeout_throw_error: true,
            on_complete: callbacks.onComplete,
            on_error: callbacks.onError,
            on_close: callbacks.onClose
        };

        try {
            hideSwitchCamera();
            window._livenessSDK.open(sdkConfig);
        } catch (error) {
            callbacks.onError?.({ message: error.message, code: 'SDK_ERROR' });
        }
    }, [config, params, callbacks]);

    return { startLiveness };
};
